import React from 'react';
import ReactQuill from 'react-quill';
import { getIn, FormikValues, FormikTouched, FormikErrors } from 'formik';
import './LocalizedQuillInput.css';
import 'react-quill/dist/quill.snow.css';

interface LocalizedQuillInputProps {
    name: string;
    formik: {
        values: FormikValues;
        touched: FormikTouched<any>;
        errors: FormikErrors<any>;
        setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
        setFieldTouched: (field: string, touched?: boolean, shouldValidate?: boolean) => void;
    };
    placeholder?: string;
    showError?: boolean;
    dataTestId?: string;
    className?: string;
    errorPath?: string;
}

const LocalizedQuillInput: React.FC<LocalizedQuillInputProps> = ({
    name,
    formik,
    placeholder = '',
    showError = true,
    dataTestId,
    className = '',
    errorPath,
}) => {
    const value = getIn(formik.values, name) || '';
    const touched = getIn(formik.touched, errorPath || name);
    const error = getIn(formik.errors, name);

    const handleChange = (val: string) => {
        formik.setFieldValue(name, val);
    };

    const handleBlur = () => {
        formik.setFieldTouched(name, true, true);
        if (errorPath && errorPath !== name) {
            formik.setFieldTouched(errorPath, true, false); 
        }
    };

    return (
        <div style={{ marginBottom: '20px' }} data-testid={dataTestId}>
        <ReactQuill
            theme="snow"
            data-testid={dataTestId}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={placeholder}
            className={className}
        />
        {showError && touched && error && (
            <small className="error">{error}</small>
        )}
        </div>
    );
};

export default LocalizedQuillInput;
